var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { TextareaContainer, TextareaSpinner, TextareaWrapper } from './styles/textarea.styled';
// eslint-disable-next-line prefer-arrow-callback
export const Textarea = forwardRef(function TextareaWithForwardRef(_a, ref) {
    var { reference, required, disabled, valid, loading, colorContext = 'on-light', color = 'default' } = _a, props = __rest(_a, ["reference", "required", "disabled", "valid", "loading", "colorContext", "color"]);
    return (React.createElement(TextareaWrapper, null,
        React.createElement(TextareaContainer, Object.assign({ id: reference, required: required, disabled: disabled, "aria-required": required, "aria-disabled": disabled }, (valid === false && { 'aria-invalid': true }), { "data-hj-suppress": true, inputRef: ref, "$invalid": valid === false, "$colorContext": colorContext, "$color": color }, props)),
        loading && React.createElement(TextareaSpinner, null)));
});
//# sourceMappingURL=Textarea.js.map